module.exports = __webpack_public_path__ + "img/order-setup-collection-heart.fa7aa0a3.svg";